import { CONDO_CORP_NAME } from './../lib/constants';
/**
 * @format
 */
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import AsyncStorage from '@react-native-async-storage/async-storage';
const debug = require('debug')('se:buildingSelectionSlice');

import { fetchCondoDataAPI, submitBuildingSelectionAPI } from '../api/adserver';
import { setUserField } from './appSlice';
import { RootState } from './rootReducer';
import { AppThunk } from './store';

interface BuildingSelectionState {
  loading: boolean;
  isSucess: boolean;
  isError: boolean;
  errMsg: string | null;
}

const initialState: BuildingSelectionState = {
  loading: false,
  isSucess: false,
  isError: false,
  errMsg: null,
};

const buildingSelectionSlice = createSlice({
  name: 'buildingSelection',
  initialState,
  reducers: {
    submitCodeProcessing(state) {
      return { ...state, loading: true, isSubmitted: true };
    },
    submitCodeSuccess(state, action) {
      return {
        ...state,
        loading: false,
        isSucess: action.payload ? true : false,
        isError: action.payload ? false : true,
      };
    },
    submitCodeFailed(state, action: PayloadAction<string>) {
      return {
        ...state,
        loading: false,
        isSucess: false,
        errMsg: action.payload,
      };
    },
  },
});

export const { submitCodeProcessing, submitCodeSuccess, submitCodeFailed } =
  buildingSelectionSlice.actions;

export const selectBuildingSelection = createSelector(
  (state: RootState) => state.buildingSelection,
  (buildingSelectionState: BuildingSelectionState) => {
    return {
      ...buildingSelectionState,
    };
  },
);

export const submitCode =
  (code: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(submitCodeProcessing());
      const data = await submitBuildingSelectionAPI(code);
      // this data is for explore
      // await AsyncStorage.setItem(CONDO_CORP_NAME, 'MTCC3275');
      // dispatch(setUserField({ field: 'corpName', value: 'MTCC3275' }));
      dispatch(submitCodeSuccess(data));
    } catch (err) {
      let message = 'unknown error';
      if (err instanceof Error) {
        message = err.toString();
      }
      dispatch(submitCodeFailed(message));
    }
  };

export const loadBuilding =
  (code: string): AppThunk =>
  async (dispatch) => {
    console.log(`loading building with code: ${code}`);
    try {
      dispatch(submitCodeProcessing());
      const data = await fetchCondoDataAPI(code);
      // this data is for explore
      // await AsyncStorage.setItem('building_code', 'MTCC3275');
      // dispatch(setUserField({ field: 'corpName', value: 'MTCC3275' }));
      dispatch(submitCodeSuccess(data));
    } catch (err) {
      console.warn('loadBuiding error', err);
      let message = 'unknown error';
      if (err instanceof Error) {
        message = err.toString();
      }
      dispatch(submitCodeFailed(message));
    }
  };

export default buildingSelectionSlice.reducer;
